import * as React from 'react';

const Default: React.SFC<unknown> = () => (
    <div className="project-add--question-builder">
        {/* TODO: Default page */}
        Loading...
    </div>
);

export default Default;
